<!-- @format -->
<template>
    <div class="call-notes-widget">
        <div class="widget-header">
            <h3>Call Notes</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>

        <div class="content-wrapper">
            <loading-svg v-if="saving || loading" />
            <div v-else>
                <label>Call Notes</label>
                <froala v-model="notes" :config="config" />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                    Close
                </app-button>
            </div>
            <div class="action-container">
                <app-button
                    :disabled="saving || loading || !notes"
                    class="save-btn"
                    @click="save()"
                >
                    Save
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const XSvg = () => import('@/components/svg/connectwise/x-svg');
const LoadingSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'call-notes-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'x-svg': XSvg,
        'loading-svg': LoadingSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            saving: false,
            notes: null,
        };
    },

    computed: {
        config() {
            return {
                fileUpload: false,
                key: this.$helpers.getFroalaKey(),

                placeholderText: 'Type Away...',
                toolbarButtons: ['bold', 'italic', 'insertLink', 'align', 'insertFile'],
            };
        },
    },

    created() {
        this.getNotes();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getNotes() {
            this.notes =
                '<p>Customer Needs:</p><ul><li>Issues with [e.g., network downtime, outdated software].</li><li>Interested in [e.g., cloud storage, security solutions].</li></ul><p>Solution Proposed:</p><ul><li>[Product/Service]: [Benefit 1, Benefit 2, etc.].</li></ul><p>Customer Questions:</p><ul><li>Integration with current systems?</li><li>Ongoing costs?</li></ul><p>Next Steps:</p><ul><li>Send proposal/demo by [Date].</li><li>Follow-up meeting on [Date].</li></ul>';
        },
    },
};
</script>
<style>
.call-notes-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.call-notes-widget .cancel-btn:hover {
    background: #e1e0e5;
}

.call-notes-widget .save-btn {
    background: #18aeff;
}

.call-notes-widget .save-btn:hover {
    background: var(--color-fill-accent-skyblue-medium); /*mass replace */
}

.call-notes-widget .content-wrapper .app-border-section .top-text {
    font:
        18px Roboto,
        sans-serif;
    font-weight: 500;
}

.call-notes-widget.widget {
    margin-bottom: 8px;
}

.call-notes-widget.widget .content-wrapper {
    padding: 24px;
}
</style>
